module.exports = __webpack_public_path__ + "img/21.44043224.png";